
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tool/map/project/[slug]",
      function () {
        return require("private-next-pages/tool/map/project/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tool/map/project/[slug]"])
      });
    }
  